import { __rest } from 'tslib';
import React from 'react';
import AntInputGroup from 'antd-core/es/input/Group';
import { extractMarginProps, extractDimensionProps, extractPaddingProps } from '@10d/tend-ui-styling';
import { useTheme } from '@10d/tend-ui-theme';
import { useAllowClear } from '../internal/useAllowClear.js';
import { useInputTitle } from '../internal/useInputTitle.js';
import { Root } from './styled.js';

const BaseInput = React.forwardRef((_a, ref) => {
    var { allowClear, clearIconTooltip, size = 'medium' } = _a, props = __rest(_a, ["allowClear", "clearIconTooltip", "size"]);
    const theme = useTheme();
    const allowClearProp = useAllowClear({ allowClear, clearIconTooltip });
    const bind = useInputTitle(props);
    const _size = {
        large: 'large',
        medium: 'middle',
        small: 'small',
    }[size];
    const _b = extractMarginProps(props), { rest: withoutMargins } = _b, margins = __rest(_b, ["rest"]);
    const _c = extractDimensionProps(Object.assign({ height: { large: 40, medium: 32, small: 24 }[size] }, withoutMargins)), { rest: withoutDimensions } = _c, dimensions = __rest(_c, ["rest"]);
    const _d = extractPaddingProps(withoutDimensions), { rest } = _d, paddings = __rest(_d, ["rest"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-input' }, rest, dimensions, margins, paddings, bind, { ref: ref, "$theme": theme, size: _size, allowClear: allowClearProp })));
});
const Input = Object.assign(BaseInput, {
    displayName: 'Input',
    Group: AntInputGroup,
});

export { Input };
//# sourceMappingURL=Input.js.map
